import React, { useState } from 'react'

import { Divider, IconButton } from '@mui/material'
import { UnfoldMore, UnfoldLess } from '@mui/icons-material'

import AvatarWithTexts from '../atoms/AvatarWithTexts'

const MailMessage = (props) => {
  const { message, ...restProps } = props
  const [expanded, setExpanded] = useState(false)

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 15,
        overflow: 'hidden',
        border: '1px solid var(--mui-palette-divider)',
        marginBottom: 10
      }}
      {...restProps}
    >
      <div className='flex items-center justify-between p-1'>
        <AvatarWithTexts
          text={message?.from_name}
          subText={message?.from_address}
        />
        <IconButton
          onClick={(e) => {
            setExpanded((prevState) => !prevState)
          }}
          color='primary'
        >
          {
            expanded
              ? <UnfoldLess/>
              : <UnfoldMore/>
          }
        </IconButton>
      </div>
      <Divider/>
      {/* <iframe src={'data:text/html,' + encodeURIComponent(message?.bodyHtml)} style={{ flexGrow: 1, width: '100%' }} sandbox=''/> */}
      <object
        id={message?.messageId}
        type="text/html"
        data={'data:text/html,' + encodeURIComponent(message?.bodyHtml)}
        style={{
          width: '100%',
          overflow: 'scroll',
          minHeight: expanded ? 400 : 200
        }}/>
    </div>
  )
}

export default MailMessage
